import { useElementSize } from "@mantine/hooks";
import { type CSSProperties, useEffect, useRef, useState } from "react";
import type { ResumeDocument } from "../api/client";
import { CvRenderer } from "./renderer";

// A4 at 96 dpi.
const PAGE_WIDTH = 793.7;

export function FitCv({
  doc,
  branded,
  className,
  maxWidth,
}: {
  doc: ResumeDocument;
  branded?: boolean;
  className?: string;
  maxWidth?: number;
}) {
  const { ref, width } = useElementSize();
  const inner = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(1123);

  useEffect(() => {
    const node = inner.current;
    if (!node) return;
    const observer = new ResizeObserver(() => setHeight(node.offsetHeight));
    observer.observe(node);
    setHeight(node.offsetHeight);
    return () => observer.disconnect();
  }, []);

  const available = maxWidth ? Math.min(width, maxWidth) : width;
  const scale = available > 0 ? Math.min(1, available / PAGE_WIDTH) : 0;

  return (
    <div ref={ref} id="cv-print" className={className} style={{ height: height * scale }}>
      <div
        ref={inner}
        className="cv-scale"
        style={
          {
            width: PAGE_WIDTH,
            maxWidth: "none",
            transform: `scale(${scale})`,
            transformOrigin: "top left",
            opacity: scale > 0 ? 1 : 0,
          } as CSSProperties
        }
      >
        <CvRenderer doc={doc} branded={branded} />
      </div>
    </div>
  );
}
